import { IconProps } from 'src/utils/icon';

const ArrowRightIcon: React.FC<IconProps> = ({ size = 1, fill = 'white' }) => (
  <svg
    style={{ fontSize: `${size}rem` }}
    viewBox="0 0 18 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.8734 0.7462L11.0848 1.55117C10.8939 1.74612 10.897 2.06321 11.0918 2.25418L14.3349 5.43363H0.482143C0.215879 5.43363 0 5.65401 0 5.92582V7.07425C0 7.34607 0.215879 7.56644 0.482143 7.56644H14.3349L11.0918 10.7459C10.897 10.9369 10.8939 11.254 11.0849 11.4489L11.8734 12.2539C12.0617 12.4461 12.367 12.4461 12.5553 12.2539L17.8508 6.84805C18.0391 6.65585 18.0391 6.34422 17.8508 6.15198L12.5552 0.7462C12.3669 0.554001 12.0616 0.554001 11.8734 0.7462Z"
      fill={fill}
    />
  </svg>
);

export default ArrowRightIcon;
